import { useElemContext } from "../../Contexts/ElemContext";
import { fetchOneStudent } from "../../services/studentService";
import { fetchOneExaminer } from "../../services/examinerService";
import { useFeedback } from "../../Contexts/FeedbackContext";
import { ERROR_UNEXPECTED } from "../../constants/feedbacks";

export default function SideBarElem({ content, contentType }) {
  const { student, setStudent, examiner, setExaminer } = useElemContext();
  const { showFeedback } = useFeedback();

  const typeConfig = {
    student: { fetcher: fetchOneStudent, setter: setStudent, current: student },
    examiner: {
      fetcher: fetchOneExaminer,
      setter: setExaminer,
      current: examiner,
    },
  };

  const { fetcher, setter, current } = typeConfig[contentType] || {};

  const handleClick = async () => {
    if (!fetcher || !setter) return;
    try {
      const res = await fetcher(content.id);
      setter(res.data);
    } catch (err) {
      showFeedback(ERROR_UNEXPECTED, false);
      console.error("Erreur:", err.message);
    }
  };

  const isSelected = current && current.id === content.id;

  const label =
    contentType === "student"
      ? `${content.name} ${content.surname}`
      : content.name;

  return (
    <button
      onClick={handleClick}
      className={`m-2 p-1 border border-black flex justify-center sm:text-sm md:text-base lg:text-lg z-0 w-[95%] ${
        isSelected
          ? "bg-secondary-yellow text-white"
          : "bg-white hover:bg-gray-100 text-black"
      }`}
    >
      <p>{label}</p>
    </button>
  );
}
